module.exports = __webpack_public_path__ + "img/onelife.aa6d1be.png";